
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import FormatPhoneNumber from "@/app/infrastructures/misc/common-library/FormatPhoneNumber";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { DetailClientManagement, ClientDetailUpdateItem } from "@/domain/entities/ClientManagement";
import { convertPhoneNumber } from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  isManagement = prop<boolean>({
    required: false,
    default: false,
    type: Boolean
  });
}
@Options({
  components: {
    Title
  }
})
class DetailContactInformation extends Vue.with(Props) {
  get detailDataManagement() {
    return ClientManagementController.detailClientManagement;
  }

  get detailDataRegistration() {
    return ClientRegistrationController.clientRegistrationDetail;
  }

  get detailData() {
    if (this.isManagement) {
      return this.detailDataManagement;
    }

    return this.detailDataRegistration;
  }

  get isMY() {
    return this.detailData.clientDistrict?.countryCode === "MY";
  }

  formatPhoneNumber(val: any) {
    return `+${this.isMY ? "60" + val : convertPhoneNumber(val)}`;
  }

  get clientContact() {
    if (this.isManagement) {
      return {
        name: this.detailDataManagement.clientContactName,
        jobTitle: this.detailDataManagement.clientContactJobTitle,
        email: this.detailDataManagement.clientContactEmail,
        phone: this.detailDataManagement.clientContactPhone
      }
    }

    return {
      name: this.detailDataRegistration.clientContact.clientContactName,
      jobTitle: this.detailDataRegistration.clientContact.clientContactJobTitle,
      email: this.detailDataRegistration.clientContact.clientContactEmail,
      phone: this.detailDataRegistration.clientContact.clientContactPhone,
    }

  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedContactInfo.length) {
      return this.detailData.detailUpdate.newestUpdatedContactInfo[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }
}
export default DetailContactInformation;
